<div class="attr-header-wrapper">
  <div class="date"><span class="date-label">Updated on</span>&nbsp;&nbsp;{{apiHitTime|
    date:'dd-MMM-y hh:mm:ss
    aaa':'en-US'}}</div>
  <div class="attr-filter-container">
    <div class="attr-align-self" *ngIf="trendAvailable && statisticsAttributeData?.attributeData?.length">
      <mat-slide-toggle (change)="onTrendChange()" [checked]="isTrend">Display Trend</mat-slide-toggle>
    </div>
    <div *ngIf="_service.rbacManagement('entities_DateTimeRangeFilter')" class="d-flex gap-2 align-items-center">
      <div class="widget-edit pdt-5 calender-pop-scroll report-date-field home-datetime-range">
        <form [formGroup]="datepickerForm">
        <app-datetime-range class="" formControlName="thisdate" [isDisabled]="false" [label]="'Date Range'" [autoApply]="false"
          [showCancel]="true" [timePicker]="true" [timePicker24Hour]="true" [timePickerSeconds]="true"
          [showCustomRangeLabel]="true" [alwaysShowCalendars]="true" [keepCalendarOpeningWithRange]="true" 
          [opens]="'left'" (datePassed)="saveTime($event)">
        </app-datetime-range>
        </form>
      </div>
    </div>
    <div *ngIf="!_service.rbacManagement('entities_DateTimeRangeFilter')" class="filter-drop-down dropdown att-filter align-end rt-filter show-arrow -mat-select-height-unset -border-bottom-none">
      <mat-form-field appearance="outline">
        <mat-select [formControl]="period" panelClass="multiSelectPanel" placeholder="Period Filter" class="-mat-select-mt-0">
          <mat-option *ngFor="let item of periodList" [value]="item" (click)="onPeriodFilterChange()">
            {{item.name | titlecase}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</div>
<div class="d-flex att-charts-wrapper gap20">
  <div class="d-flex flex-column attr-list-container attr-ellipsis uni-attr-list-container"  *ngIf="!_service?.rbacManagement('vehicles_Enrolled_AnalyticsFramework')">
    <div *ngFor="let attr of attributesList; let i = index" (click)="onAttrSelect(i)" class="cursor"
      [ngClass]="{'selectedAttr uni-selectedAttr': attr?.isSelected}" [matTooltip]="attr?.name">
      <span>{{attr?.attributeName ? attr?.attributeName : attr?.name}}</span>
    </div>
  </div>
  <mat-tab-group animationDuration="0ms" (selectedTabChange)="tabChanged($event)" [selectedIndex]="selectedTabIndex"  *ngIf="_service?.rbacManagement('vehicles_Enrolled_AnalyticsFramework')">
    <mat-tab  label="Default">
      <div class="d-flex flex-column attr-list-container-analytics attr-ellipsis uni-attr-list-container">
        <div *ngFor="let attr of attributesList; let i = index" (click)="onAttrSelect(i)" class="cursor"
          [ngClass]="{'selectedAttr uni-selectedAttr': attr?.isSelected}" [matTooltip]="domain === 'MGM' ? '' : attr?.name">
          <span>{{attr?.attributeName ? attr?.attributeName : attr?.name}}</span>
        </div>
      </div>
    </mat-tab>
    <mat-tab  label="Build Your own Chart" *ngIf="_service?.rbacManagement('vehicles_Enrolled_AnalyticsFramework')">
      <form [formGroup]="chartBuildForm" class="entity-onboard-wrapper">
        <div class="make-responsive-entitiesList">
          <div>
            <mat-form-field appearance="outline">
              <mat-select formControlName="xAxis" panelClass="multiSelectPanel" placeholder="X Axis" class="-mat-select-mt-0">
                <mat-option *ngFor="let item of chartBuilderFields?.xAxis" [value]="item" >
                  {{item.attributeName | titlecase}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            </div>
            <div>
              <mat-form-field appearance="outline" >
                <mat-select formControlName="yAxis" panelClass="multiSelectPanel" placeholder="Y Axis" class="-mat-select-mt-0">
                  <mat-option *ngFor="let item of chartBuilderFields?.yAxis" [value]="item" >
                    {{item.attributeName | titlecase}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field appearance="outline" >
                <mat-select formControlName="yAxis2" panelClass="multiSelectPanel" placeholder="Y Axis2" class="-mat-select-mt-0">
                  <mat-option *ngFor="let item of chartBuilderFields?.yAxis2" [value]="item" >
                    {{item.attributeName | titlecase}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
        </div>
        <div>
          <mat-form-field appearance="outline" class="byc-dropdown-chart">
            <mat-select formControlName="chartType" panelClass="multiSelectPanel" placeholder="Chart Type" class="-mat-select-mt-0">
              <mat-option *ngFor="let item of chartBuilderFields?.chartType" [value]="item" >
                {{item.name | titlecase}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="eo-action-list -end">
          <app-button [label]="'Clear'" (clicked)="onFormActionClear()">
          </app-button>
          <app-button [label]="'Plot Now'" (clicked)="onFormActionClick($event)" [disabled]="!chartBuildForm?.value?.xAxis || !chartBuildForm?.value?.yAxis || !chartBuildForm?.value?.chartType">
          </app-button>
        </div>
      </form>
    </mat-tab>
  </mat-tab-group>
  <div class="attr-chart-container d-flex flex-column gap20" *ngIf="_service?.rbacManagement('vehicles_Enrolled_AnalyticsFramework') ? selectedTabIndex === 0 : true">
    <div *ngIf="isLoader" class="h-100 w-100 padt-5">
      <mat-progress-bar [mode]="'indeterminate'">
      </mat-progress-bar>
    </div>
    <div class="d-flex flex-column chart-area" *ngIf="!isLoader && statisticsAttributeData?.attributeData?.length">
      <div class="attr-title">{{selectedAttr?.attributeName ? selectedAttr?.attributeName :
        selectedAttr?.name}}<span class="att-uom" *ngIf="selectedAttr?.uom">&nbsp;&nbsp;{{selectedAttr?.uom}}</span>
      </div>
      <div class="d-flex flex-column split-count gap20"
        *ngIf="!isLoader && statisticsAttributeData?.attributeData?.length">
        <div class="attr-title">Statistics</div>
        <div class="d-flex gap20">
          <div class="stat-box d-flex flex-column" *ngFor="let stat of statsSplit; let i = index"
            [ngClass]="{'alt-box1': (i%2)===0,'alt-box2': (i%2)!==0}">
            <span class="attr-ellipsis stat-name" [matTooltip]="stat?.name">{{stat?.name}}</span>
            <span class="attr-ellipsis stat-value" *ngIf="stat?.value||stat?.value===0"
              [matTooltip]="stat?.value">{{ stat?.value.toFixed(3) }}</span>
            <span *ngIf="!stat?.value" class="stat-value-no-data">No Data</span>
          </div>
        </div>
      </div>
      <div class="chart">
        <app-attribute-line-chart
          [lineData]="statisticsAttributeData?.attributeData?.length?statisticsAttributeData?.attributeData:[]"
          (dataZoom)="dataZoom($event)" [attributeData]="attributeData" [selectedAttribute]="selectedAttr">
        </app-attribute-line-chart>
      </div>
    </div>
    <div *ngIf="!isLoader && !statisticsAttributeData?.attributeData?.length" class="text-center">
      <img src="../../../../../../assets/images/no-data-idec.svg" matToolTip="No Data" class="h-150" alt="no data">
    </div>
  </div>
  <div class="attr-chart-container d-flex flex-column gap20" *ngIf="selectedTabIndex === 1 && _service?.rbacManagement('vehicles_Enrolled_AnalyticsFramework')">
    <app-chart-builder [entityDetails]="entityData" [hideStatistics]="false"></app-chart-builder>
  </div>
</div>